import { render, staticRenderFns } from "./showArticleCover.vue?vue&type=template&id=6d7c71ae&scoped=true"
import script from "./showArticleCover.vue?vue&type=script&lang=js"
export * from "./showArticleCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7c71ae",
  null
  
)

export default component.exports